module.exports = __webpack_public_path__ + "static/media/b3_p8_clickable.1541d7c6.mp3";